/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-control[_ngcontent-%COMP%]{cursor:pointer;width:50%;display:inline-block;margin-bottom:16px}.form-control[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .form-control[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{cursor:pointer}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/components/_shared/checklist/checklist.component.scss.shim.ngstyle.js.pre-build-optimizer.js